module.exports = __webpack_public_path__ + "img/icon-account-personal-data-green@3x.f82f3c47.png";